import { createElement } from 'react'
import { usePageLayout } from './usePageLayout'
import useLoginStore from '@/store/LoginStore'
import TaskSidebar from '@/components/app/sidebars/task'

export const useTaskPageSetup = () => {
  usePageLayout({
    sidebarContent: createElement(TaskSidebar),
  })

  const workspaceSlug = useLoginStore((state) => state.workspaceSlug)

  return { workspaceSlug }
}
